import { ChainId } from '@venusprotocol/chains';

export const SUNSET_CHAIN_IDS: ChainId[] = [
  ChainId.OPBNB_MAINNET,
  ChainId.OPBNB_TESTNET,
  ChainId.OPTIMISM_MAINNET,
  ChainId.OPTIMISM_SEPOLIA,
  ChainId.UNICHAIN_MAINNET,
  ChainId.UNICHAIN_SEPOLIA,
];
